"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.barrierQueue = exports.processWorkQueue = void 0;
async function processWorkQueue(queue, queueDelay = 200) {
    while (queue && queue.length > 0) {
        const v = queue.shift();
        if (v) {
            try {
                const ret = await v.next();
                v.resolve(ret);
            }
            catch (e) {
                v.reject(e);
            }
        }
    }
    setTimeout(() => processWorkQueue(queue, queueDelay), queueDelay);
}
exports.processWorkQueue = processWorkQueue;
const barrierQueue = async (queue, then) => {
    return new Promise((resolve, reject) => {
        queue.push({
            next: then,
            resolve,
            reject,
        });
    });
};
exports.barrierQueue = barrierQueue;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid29yay1xdWV1ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy93b3JrLXF1ZXVlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU1PLEtBQUssVUFBVSxnQkFBZ0IsQ0FBQyxLQUE0QixFQUFFLFVBQVUsR0FBRyxHQUFHO0lBQ25GLE9BQU8sS0FBSyxJQUFJLEtBQUssQ0FBQyxNQUFNLEdBQUcsQ0FBQyxFQUFFO1FBQ2hDLE1BQU0sQ0FBQyxHQUFHLEtBQUssQ0FBQyxLQUFLLEVBQUUsQ0FBQztRQUN4QixJQUFJLENBQUMsRUFBRTtZQUNMLElBQUk7Z0JBQ0YsTUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUM7Z0JBQzNCLENBQUMsQ0FBQyxPQUFPLENBQUMsR0FBRyxDQUFDLENBQUM7YUFDaEI7WUFBQyxPQUFPLENBQUMsRUFBRTtnQkFDVixDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO2FBQ2I7U0FDRjtLQUNGO0lBQ0QsVUFBVSxDQUFDLEdBQUcsRUFBRSxDQUFDLGdCQUFnQixDQUFDLEtBQUssRUFBRSxVQUFVLENBQUMsRUFBRSxVQUFVLENBQUMsQ0FBQztBQUNwRSxDQUFDO0FBYkQsNENBYUM7QUFFTSxNQUFNLFlBQVksR0FBRyxLQUFLLEVBQUssS0FBMkIsRUFBRSxJQUFzQixFQUFjLEVBQUU7SUFDdkcsT0FBTyxJQUFJLE9BQU8sQ0FBSSxDQUFDLE9BQU8sRUFBRSxNQUFNLEVBQUUsRUFBRTtRQUN4QyxLQUFLLENBQUMsSUFBSSxDQUFDO1lBQ1QsSUFBSSxFQUFFLElBQUk7WUFDVixPQUFPO1lBQ1AsTUFBTTtTQUNQLENBQUMsQ0FBQztJQUNMLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyxDQUFDO0FBUlcsUUFBQSxZQUFZLGdCQVF2QiJ9